import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconTag as BaseIconTag, Button } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledUsersIcon = styled(FontAwesomeIcon)`
  font-size: ${({ theme }) => theme.fonts.sizes.medium};
  color: ${({ theme }) => theme.colors.info.main};
`;

export const StyledHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  margin-bottom: 1.5rem;
`;

export const StyledHeading = styled.span`
  font-size: ${({ theme }) => theme.fonts.sizes.medium};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  color: ${({ theme }) => theme.colors.text.main};
`;
export const StyledOptionsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1.6rem;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    justify-content: flex-end;
  }
`;
export const StyledSearchIcon = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.colors.grey[700]};
`;

export const StyledStatusIcon = styled(FontAwesomeIcon)`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  color: ${({ theme }) => theme.colors.success.main};
`;

export const StyledResetIcon = styled(FontAwesomeIcon)`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  color: ${({ theme }) => theme.colors.grey[600]};
`;

export const StyledRecordsContainer = styled.div`
  flex-basis: 22rem;
`;

export const StyledSearchContainer = styled.div`
  flex-basis: 45.2rem;
`;

export const StyledDefaultText = styled.div`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  color: ${({ theme }) => theme.colors.text.main};
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 2;
`;

export const StyledAvatarContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
`;

export const StyledPublicStatusTag = styled(BaseIconTag)`
  &&& {
    background-color: ${({ theme }) => theme.colors.info.lightest};
  }
`;

export const StyledDraftStatusTag = styled(BaseIconTag)`
  &&& {
    background-color: ${({ theme }) => theme.colors.grey[700]};
    color: ${({ theme }) => theme.colors.white};
  }
`;

export const StyledPaginationContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    justify-content: center;
    gap: 2.4rem;
  }
`;

export const StyledRecordDetailText = styled.span`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  color: ${({ theme }) => theme.colors.text.lighter};
`;

export const StyledChangesContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const StyledModularTableWrapper = styled.div`
  margin-top: 2.4rem;
  margin-bottom: 2.4rem;

  div[role='table'] {
    overflow: unset;
    border-radius: ${({ theme }) => theme.radius.small};
    border: 0.1rem solid ${({ theme }) => theme.colors.border.main};
    @media (max-width: ${({ theme }) => theme.sizes.md}) {
      box-shadow: none;
    }
  }

  div[role='row'] {
    position: relative;
    transition: background-color 0.2s linear;
    padding: 3rem 0.5rem;
    @media (max-width: ${({ theme }) => theme.sizes.md}) {
      border: none;
      :not(:first-child) {
        border-top: 0.1rem solid ${({ theme }) => theme.colors.border.light};
      }
      :first-child:has(div[role='cell']) {
        border-top-right-radius: ${({ theme }) => theme.radius.small};
        border-top-left-radius: ${({ theme }) => theme.radius.small};
      }
    }
    @media (min-width: ${({ theme }) => theme.sizes.md}) {
      padding: 0;
      :first-child:has(div[role='columnheader']) {
        border-top-right-radius: ${({ theme }) => theme.radius.small};
        border-top-left-radius: ${({ theme }) => theme.radius.small};
      }
    }
    :last-child:has(div[role='cell']) {
      border-bottom-right-radius: ${({ theme }) => theme.radius.small};
      border-bottom-left-radius: ${({ theme }) => theme.radius.small};
    }
  }

  div[role='cell'] {
    @media (max-width: ${({ theme }) => theme.sizes.md}) {
      padding: 1rem;

      > div {
        flex: 1;
        :first-child {
          display: flex;
          align-items: center;
          margin-right: 1rem;
          flex: 0 1 40%;
        }
      }
    }
  }

  div[role='columnheader'] {
    justify-content: space-between;
  }
`;

export const ButtonWrapper = styled.div`
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
`;

export const StyledViewButton = styled(Button)`
  &:hover {
    background-color: ${({ theme }) => theme.colors.secondary.main};
    color: ${({ theme }) => theme.colors.white};
    border-color: ${({ theme }) => theme.colors.secondary.lighter};
  }
  font-size: ${({ theme }) => theme.fonts.sizes.small};
`;

export const StyledHtmlContentContainer = styled.div`
  padding: 1.6rem 0;
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  line-height: 2.4rem;
`;

export const StyledChangesText = styled(StyledDefaultText)`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  line-height: 2.2rem;
  max-height: 2.2rem;
`;
